module.exports = __webpack_public_path__ + "img/ic_price_calendar_center_img.1fb2e39f.png";